import dayjs from 'dayjs'

export const getMinDepositRate = (startDate: Date): number => {
  const today = dayjs()
  const todayFormatted = dayjs(today)
  const startDateFormatted = dayjs(startDate)

  const monthsUntilStartDate = startDateFormatted.diff(
    todayFormatted,
    'month',
    true,
  )

  let minRate: number

  if (monthsUntilStartDate <= 1) {
    minRate = 100
  } else if (monthsUntilStartDate <= 2) {
    minRate = 70
  } else {
    minRate = 60
  }

  return minRate
}
